<template lang="pug">
.schedule
  //- Barra de navegación
  van-nav-bar(:title="$t('schedule.title')")
    van-icon(name="menu" slot="left" @click="openSidenav")

  //- Barra de los días de la semana
  .schedule__days
    .schedule__day(
      v-if="!mondayFirstDay"
      :class="{'select': day === 0}"
      @click="setDay(0)") {{ $t('schedule.shortDay.SU') }}
    .schedule__day(
      :class="{'select': day === 1}"
      @click="setDay(1)") {{ $t('schedule.shortDay.MO') }}
    .schedule__day(
      :class="{'select': day === 2}"
      @click="setDay(2)") {{ $t('schedule.shortDay.TU') }}
    .schedule__day(
      :class="{'select': day === 3}"
      @click="setDay(3)") {{ $t('schedule.shortDay.WE') }}
    .schedule__day(
      :class="{'select': day === 4}"
      @click="setDay(4)") {{ $t('schedule.shortDay.TH') }}
    .schedule__day(
      :class="{'select': day === 5}"
      @click="setDay(5)") {{ $t('schedule.shortDay.FR') }}
    .schedule__day(
      :class="{'select': day === 6}"
      @click="setDay(6)") {{ $t('schedule.shortDay.SA') }}
    .schedule__day(
      v-if="mondayFirstDay"
      :class="{'select': day === 0}"
      @click="setDay(0)") {{ $t('schedule.shortDay.SU') }}

  .main
    //- Instalaciones de Clima
    .home__title.media.media--center(v-if="installations")
      .media__body {{ $t('home.allUnits') }}
    .units__installations
      InstallationsRow(
        v-for="(installation, installationID) in installations"
        :key="installationID"
        :day="day"
        :installationID="installationID"
        @addSchedule="showManageSchedules"
        @updateSchedule="showManageSchedules")

    //- Instalaciones de ACS
    .home__title.media.media--center(v-if="installationsACS")
      .media__body {{ $t('home.allUnitsACS') }}
    .units__installations(v-if="installationsACS")
      InstallationsRow(
        v-for="(installation, installationID) in installationsACS"
        :key="installationID"
        :day="day"
        :ACSMode="true"
        :installationID="installationID"
        @addSchedule="showManageSchedules"
        @updateSchedule="showManageSchedules")

    //- Mensaje cuando no hay ninguna instalación
    .padding(v-if="!installations")
      img.addUnit__img(src="@/assets/img/addUnitBluetooth.png")

      .addUnit__message.margin-double-bottom.margin-double-top
        .addUnit__message__title {{ $t('home.empty.title') }}
        | {{ $t('home.empty.message') }}

      router-link.van-button.van-button--primary.van-button--large(to="/main/addUnit")
        | {{ $t('sidenav.addUnit') }}

  //- Modal para crear/editar programaciones
  van-popup.van-popup--full(
    :value="openManageSchedules"
    position="right"
    :overlay="false")

    ManageSchedules(
      v-if="openManageSchedules"
      :installationID="installationID"
      :schedule="schedule"
      :ACSMode="ACSMode"
      @close="hideManageSchedules")
</template>

<script>
import InstallationsRow from '@/components/Schedules/InstallationsRow.vue';
import ManageSchedules from '@/components/Schedules/ManageSchedules.vue';
import { CONFIG } from '@/app.config';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { InstallationsRow, ManageSchedules },

  data() {
    return {
      day: this.getToday(),
      mondayFirstDay: CONFIG.MONDAY_FIRSTDAY,
      openManageSchedules: false,
      installationID: '',
      schedule: null,
      ACSMode: false,
    };
  },

  computed: {
    ...mapGetters({
      getAdvancedInstallations: 'unitsModule/getAdvancedInstallations',
    }),

    /**
     * Devuelve todas las instalaciones en las que el usuario es avanzado
     */
    installations() {
      return this.getAdvancedInstallations();
    },

    /**
     * Devuelve todas las instalaciones ACS en las que el usuario es avanzado
     */
    installationsACS() {
      const installations = this.getAdvancedInstallations(true);
      return Object.keys(installations).length > 0 ? installations : null;
    },
  },

  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    /**
     * Devuelve el día de la semana,
     * primero comprobamos si hemos pasado alguno mediante la url
     */
    getToday() {
      if (this.$route.params.day) return this.$route.params.day;

      const today = new Date();
      return today.getDay();
    },

    /**
     * Selecciona un nuevo día de la seman
     */
    setDay(day) {
      this.day = day;
    },

    /**
     * Muestra el modal para editar/crear una programación
     */
    showManageSchedules(data) {
      this.installationID = data.installationID;
      this.schedule = data.schedule || null;
      this.ACSMode = data.ACSMode;
      this.openManageSchedules = true;
    },

    /**
     * Oculta el modal para editar/crear una programación
     */
    hideManageSchedules() {
      this.installationID = '';
      this.schedule = null;
      this.openManageSchedules = false;
    },
  },
};
</script>
